import React from 'react';
import { Box, Typography, Button, Container, Paper } from '@mui/material';
import { ErrorOutline, FindInPageOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const containerStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '70vh',
  padding: '16px',
};

const paperStyles = {
  textAlign: 'center',
  p: { xs: 3, sm: 5 },
  borderRadius: '16px',
  boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.1)',
  backdropFilter: 'blur(4px)',
  border: '1px solid rgba(255, 255, 255, 0.18)',
  maxWidth: '500px',
  width: '100%',
  color: '#4a148c', // Purple text
};

const iconStyles = {
  fontSize: '5rem',
  color: '#f759ab', // Pink icon
};

const buttonStyles = {
  mt: 3,
  backgroundColor: '#f759ab', // Pink button
  color: '#fff',
  fontWeight: 'bold',
  borderRadius: '8px',
  padding: '10px 24px',
  '&:hover': {
    backgroundColor: '#e94a9c',
    boxShadow: '0 4px 14px 0 rgba(247, 89, 171, 0.39)',
  },
};

export function InvoiceError({ onRetry }) {
  return (
    <Box sx={containerStyles}>
      <Paper sx={{ ...paperStyles, backgroundColor: 'rgba(255, 255, 255, 0.85)' }}>
        <ErrorOutline sx={iconStyles} />
        <Typography variant="h4" component="h2" sx={{ mt: 2, fontWeight: 'bold' }}>
          ¡Ups! Algo salió mal
        </Typography>
        <Typography variant="body1" sx={{ my: 2, color: '#555' }}>
          No pudimos cargar la información de la factura en este momento. Por favor, verifica tu conexión e inténtalo de nuevo.
        </Typography>
        <Button sx={buttonStyles} onClick={onRetry}>
          Reintentar
        </Button>
      </Paper>
    </Box>
  );
}

export function InvoiceNotFound() {
  const navigate = useNavigate();
  return (
    <Box sx={containerStyles}>
      <Paper sx={{ ...paperStyles, backgroundColor: 'rgba(255, 255, 255, 0.85)' }}>
        <FindInPageOutlined sx={iconStyles} />
        <Typography variant="h4" component="h2" sx={{ mt: 2, fontWeight: 'bold' }}>
          No encontramos nada por aquí
        </Typography>
        <Typography variant="body1" sx={{ my: 2, color: '#555' }}>
          La factura que buscas no existe, fue movida o quizás nunca existió.
        </Typography>
        <Button sx={buttonStyles} onClick={() => navigate('/invoices')}>
          Volver al listado
        </Button>
      </Paper>
    </Box>
  );
}
